import httpClient from '@/lib/httpClient.js'
import { useMutation } from '@tanstack/react-query'
import { handleFormError } from '@/utils/helpers.js'
import { toast } from 'sonner'

export default function useCreateTeam({ setError, clientServerFieldMapping }) {
  const action = async ({
    name,
    teamType,
    dateAsOf = null,
    balance = null,
    abn = null,
  }) => {
    const response = await httpClient.post('team/team', {
      name,
      team_type: teamType,
      ...(abn?.trim() ? { abn: abn.replace(/\s+/g, '') } : {}),
      date_as_of: dateAsOf,
      balance,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (e) => {
      toast.success(e?.response?.data?.message ?? 'Space has been created')
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        showToast: true,
        clientServerFieldMapping,
      }),
  })

  return {
    createTeam: mutation.mutateAsync,
    createTeamStatus: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
